import {action, observable, computed, makeObservable} from 'mobx';

export class CompaniesStore {
    @observable searchValue;
    @observable companiesToShow;
    _companies: Company[];

    constructor(data) {
        makeObservable(this);

        this._companies = [];

        data.forEach(company => {
            const newComp = new Company(company);
            this._companies.push(newComp);
        });

        this.companiesToShow = this.sortCompanies(this._companies);
    }

    get totalNumOfResults() {
        return this._companies.length;
    }

    @computed
    get companies() {
        return this.companiesToShow.slice();
    }

    @action
    setValue(value) {
        this.searchValue = value;
        this.companiesToShow = this.setCompanies();
    }

    setCompanies() {
        if (this.searchValue?.length) {
            const filteredOptions = this._companies.filter(company => {
                return company.label.toLowerCase().includes(this.searchValue.toLowerCase());
            });
            return this.sortCompanies(filteredOptions);
        } else {
            return this.sortCompanies(this._companies);
        }
    }

    sortCompanies(companies) {
        return companies.sort((comp1, comp2) => {
            return comp2.isSelected - comp1.isSelected;
        });
    }

    @computed
    get selectedCompanies() {
        return this._companies.filter(company => company.isSelected);
    }

    @computed
    get selectedCompaniesCount() {
        return this.selectedCompanies ? this.selectedCompanies.length : 0;
    }

    @action
    setAllSelected(filteredCompanies) {
        if (!this.isAllSelected) {
            filteredCompanies.forEach(company => {
                company.setSelected(true);
            });
        } else {
            filteredCompanies.forEach(company => {
                company.setSelected(false);
            });
        }
    }

    @computed
    get isAllSelected() {
        if (this.companiesToShow.length) {
            return !this.companiesToShow.some(company => !company.isSelected);
        }
        return false;
    }
}

export class Company {
    value: string;
    @observable isSelected: number;
    label: string;

    constructor(data) {
        makeObservable(this);
        this.value = data.data;
        this.isSelected = parseInt(data.selected);
        this.label = data.company;
    }

    @action
    setSelected(value) {
        this.isSelected = value ? 1 : 0;
    }
}
